import { render } from "./AudienceStatsButtons.vue?vue&type=template&id=4fdca514&scoped=true"
import script from "./AudienceStatsButtons.vue?vue&type=script&lang=js"
export * from "./AudienceStatsButtons.vue?vue&type=script&lang=js"

import "./AudienceStatsButtons.vue?vue&type=style&index=0&id=4fdca514&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fdca514"]])

export default __exports__